<template>
<div class="chapter">
<div class="inner_page">
<p class="P12"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C186"><a id="page_vii"></a><a href="#/xhtml/05_LIST_OF_TABLES_AND_FIGURES#page_ix">LIST OF TABLES AND FIGURES</a></p>
<p class="C187"><a href="#/xhtml/06_ACKNOWLEDGMENTS#page_xiii">ACKNOWLEDGMENTS</a></p>
<p class="C186"><a href="#/xhtml/07_Introduction__Obesity_and_the_Ne#page_1">Introduction: <em>Obesity and the Neoliberal Diet</em></a></p>
<p class="C186"><span href="#/xhtml/08_1__The_Neoliberal_Food_Regime_an#page_26" title="Link target outside of Sample">1. The Neoliberal Food Regime and Its Crisis: <em>The Dynamic Factors</em></span></p>
<p class="C186"><span href="#/xhtml/09_2__Neoregulation_of_Agricultural#page_58" title="Link target outside of Sample">2. Neoregulation of Agricultural Biotechnology at the National and Suprastate Scales</span></p>
<p class="C186"><span href="#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_80" title="Link target outside of Sample">3. Food and Inequality in the United States</span></p>
<p class="C186"><span href="#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_101" title="Link target outside of Sample">4. Class Diets in the NAFTA Region: <em>Divergence or Convergence?</em></span></p>
<p class="C186"><span href="#/xhtml/12_5__NAFTA__Agriculture__and_Work#page_124" title="Link target outside of Sample">5. NAFTA, Agriculture, and Work: <em>Mexico’s Loss of Food and Labor Sovereignty</em></span></p>
<p class="C186"><span href="#/xhtml/13_6__Globalizing_the_Neoliberal_Di#page_150" title="Link target outside of Sample">6. Globalizing the Neoliberal Diet: <em>Food Security and Trade</em></span></p>
<p class="C186"><span href="#/xhtml/14_7__Food_Security__Obesity__and_I#page_168" id="page_viii" title="Link target outside of Sample">7. Food Security, Obesity, and Inequality: <em>Measuring the Risk of Exposure to the Neoliberal Diet</em></span></p>
<p class="C187"><span href="#/xhtml/15_Conclusion__What_Is_to_Be_Done#page_187" title="Link target outside of Sample">Conclusion: <em>What Is to Be Done?</em></span></p>
<p class="C186"><span href="#/xhtml/16_REFERENCES#page_197" title="Link target outside of Sample">REFERENCES</span></p>
<p class="C186"><span href="#/xhtml/17_INDEX#page_229" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?33e79588